import { LOAD_PROJECT_ANALYSIS_REPORT, ERROR, FILTER_PROJECT_ANALYSIS_REPORT, UPDATE_FILTERS_APPLIED, UNPIN_CLIP, CREATE_NEW_HIGHLIGHT_REEL, ADD_CLIP_TO_HIGHLIGHT_REEL, REMOVE_CLIP_FROM_HIGHLIGHT_REEL, REORDER_CLIPS_IN_HIGHLIGHT_REEL, DOWNLOAD_HIGHLIGHT_REEL, GET_DOWNLOAD_HIGHLIGHT_REEL_STATUS, RESET_PROJECT_ANALYSIS_REPORT, DELETE_HIGHLIGHT_REEL, ADD_INSIGHT, UPDATE_INSIGHT, DELETE_INSIGHT } from "../actions/types";
import { FILTER_SPACE_BY_RESPONDENT_SESSION, FILTER_SPACE_BY_SEARCH_KEYWORDS, FILTER_SPACE_BY_TAGS, REEL_READY } from "../actions/constants";

const initialState = {
  error: null,
  referrer: null,
  isLoading: true,
  apiData: null,
  renderingData: {},
  filtersApplied: {
    FILTER_SPACE_BY_RESPONDENT_SESSION: 0,
    FILTER_SPACE_BY_SEARCH_KEYWORDS: '',
    FILTER_SPACE_BY_TAGS: []
  }
};

const projectAnalysisReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RESET_PROJECT_ANALYSIS_REPORT:
      return { ...state, isLoading: true, error: null, ...initialState };

    case LOAD_PROJECT_ANALYSIS_REPORT:
      return { ...state, isLoading: false, error: null, ...payload };

    case UNPIN_CLIP:
      const unpinClipId = payload.analysisSpaceModel.id;
      const renderingDataIndex = state.renderingData.findIndex(s => Number(s.id) === Number(unpinClipId));
      if (renderingDataIndex !== -1) {
        state.renderingData.splice(renderingDataIndex, 1);
      }
      let apiDataIndex = -1;;
      Object.entries(state.apiData.space).forEach(s => { if (Number(s[1].id) === Number(unpinClipId)) apiDataIndex = s[0] });
      if (apiDataIndex !== -1) {
        delete state.apiData.space[apiDataIndex];
      }
      const highlightReelsModel = payload.highlightReelsModel;
      if (highlightReelsModel && highlightReelsModel.length) {
        highlightReelsModel.forEach(reel => {
          if (!reel.error) {
            state.apiData.highlightReels.find(r => Number(r.id) === Number(reel.model.id)).space_ids = reel.model.space_ids;
            state.apiData.highlightReels.find(r => Number(r.id) === Number(reel.model.id)).status = reel.model.status;
          }
        });
      }
      return { ...state, isLoading: false, error: null };

    case CREATE_NEW_HIGHLIGHT_REEL:
      state.apiData.highlightReels.unshift(payload.data);
      return { ...state, isLoading: false, error: null };

    case ADD_INSIGHT:
      state.apiData.insights.unshift(payload.data);
      return { ...state, isLoading: false, error: null };

    case UPDATE_INSIGHT:
      const insights = [...state.apiData.insights];
      const index = insights.findIndex(i => Number(i.id) === Number(payload.data.id));
      if (index !== -1) {
        insights[index] = payload.data;
      }
      state.apiData.insights = insights;
      return { ...state, isLoading: false, error: null };

    case DELETE_INSIGHT:
      const allInsights = [...state.apiData.insights];
      const delIndex = allInsights.findIndex(i => Number(i.id) === Number(payload.data.id));
      if (delIndex !== -1) {
        allInsights.splice(delIndex, 1);
      }
      state.apiData.insights = allInsights;
      return { ...state, isLoading: false, error: null };

    case DELETE_HIGHLIGHT_REEL:
      if (payload.data.error == null) {
        const inx = state.apiData.highlightReels.findIndex(r => Number(r.id) === Number(payload.data.model.id));
        if (inx > -1) {
          state.apiData.highlightReels.splice(inx, 1);
        }
      }
      return { ...state, isLoading: false, error: null };

    case ADD_CLIP_TO_HIGHLIGHT_REEL:
    case REMOVE_CLIP_FROM_HIGHLIGHT_REEL:
    case REORDER_CLIPS_IN_HIGHLIGHT_REEL:
    case DOWNLOAD_HIGHLIGHT_REEL:
      if (payload.data.error == null) {
        state.apiData.highlightReels.find(r => Number(r.id) === Number(payload.data.model.id)).space_ids = payload.data.model.space_ids;
        state.apiData.highlightReels.find(r => Number(r.id) === Number(payload.data.model.id)).status = payload.data.model.status;
      }
      return { ...state, isLoading: false, error: null };

    case GET_DOWNLOAD_HIGHLIGHT_REEL_STATUS:
      payload.data.forEach(reel => {
        state.apiData.highlightReels.find(r => Number(r.id) === Number(reel.id)).status = REEL_READY;
        state.apiData.highlightReels.find(r => Number(r.id) === Number(reel.id)).url = reel.url;
      });
      return { ...state, isLoading: false, error: null };

    case UPDATE_FILTERS_APPLIED:
      const { updateFilterType, updateFilterKey } = payload;
      if (updateFilterType === FILTER_SPACE_BY_RESPONDENT_SESSION) {
        return { ...state, isLoading: false, error: null, filtersApplied: { ...state.filtersApplied, FILTER_SPACE_BY_RESPONDENT_SESSION: updateFilterKey } };
      } else if (updateFilterType === FILTER_SPACE_BY_SEARCH_KEYWORDS) {
        return { ...state, isLoading: false, error: null, filtersApplied: { ...state.filtersApplied, FILTER_SPACE_BY_SEARCH_KEYWORDS: updateFilterKey } };
      } else if (updateFilterType === FILTER_SPACE_BY_TAGS) {
        return { ...state, isLoading: false, error: null, filtersApplied: { ...state.filtersApplied, FILTER_SPACE_BY_TAGS: updateFilterKey } };
      }
      break;

    case FILTER_PROJECT_ANALYSIS_REPORT:
      let filteredData = Object.values(state.apiData.space);
      Object.keys(state.filtersApplied).forEach(filterType => {
        const filterKey = state.filtersApplied[filterType];
        if (filterType === FILTER_SPACE_BY_RESPONDENT_SESSION) {
          filteredData = Number(filterKey) === 0 ? filteredData : filteredData.filter(s => s.session_id === filterKey);
        } else if (filterType === FILTER_SPACE_BY_SEARCH_KEYWORDS) {
          filteredData = filterKey === '' ? filteredData : filteredData.filter(s => {
            const d = JSON.parse(s.data);
            return (d.comment && d.comment.toLowerCase().indexOf(filterKey) !== -1) || (d.user_type && d.user_type.toLowerCase().indexOf(filterKey) !== -1) || (d.user_name && d.user_name.toLowerCase().indexOf(filterKey) !== -1) || (d.destination_file && d.destination_file.toLowerCase().indexOf(filterKey) !== -1) || (state.apiData.session?.find(x => x.id === s.session_id)?.name.toLowerCase().indexOf(filterKey) !== -1) || (state.apiData.session.find(x => x.id === s.session_id)?.participant_name.toLowerCase().indexOf(filterKey) !== -1);
          });
        } else if (filterType === FILTER_SPACE_BY_TAGS) {
          filteredData = filterKey.length === 0 ? filteredData : filteredData.filter(s => {
            let tags = [];
            if (s.ranges && s.ranges.length) {
              s.ranges.forEach(r => {
                r.tags.split(',').forEach(t => {
                  if (tags.indexOf(t) === -1)
                    tags.push(t);
                });
              });
            } else if (JSON.parse(s.data)) {
              tags = JSON.parse(s.data)?.tags?.split(',')
            }
            return filterKey.some(e => tags?.includes(e));
          });
        }
      });
      return { ...state, isLoading: false, error: null, renderingData: filteredData };

    case ERROR:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default projectAnalysisReducer;
